import { ExternalLink } from "lucide-react";
import { SITE } from "@/lib/site";

const styles = {
  primary:
    "bg-[#1F6FEB] text-white hover:bg-[#1655B8] hover:-translate-y-0.5 shadow-sm hover:shadow-md",
  onDark:
    "bg-white text-[#0B1F33] hover:bg-[#F4F6F8] hover:-translate-y-0.5 shadow-sm",
  outline:
    "border-2 border-[#0B1F33] text-[#0B1F33] hover:bg-[#F4F6F8] hover:-translate-y-0.5",
  outlineLight:
    "border-2 border-white/80 text-white hover:bg-white/10 hover:-translate-y-0.5",
};

export const AmazonButton = ({
  children = "Shop on Amazon",
  variant = "primary",
  testId,
  className = "",
}) => (
  <a
    href={SITE.amazonStore}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 text-sm font-semibold transition-[background-color,transform,box-shadow] duration-200 ${styles[variant]} ${className}`}
  >
    {children}
    <ExternalLink className="h-4 w-4" aria-hidden="true" />
    <span className="sr-only">(opens in a new tab)</span>
  </a>
);

export default AmazonButton;
